export const STATUS_VALUES = {
	ACTIVE: 1,
	INACTIVE: 0,
};

export const STATUS_LIST = [
	{ label: 'Active', value: STATUS_VALUES.ACTIVE },
	{ label: 'Inactive', value: STATUS_VALUES.INACTIVE },
];

export const STATUS_OBJECT = {
	true: { label: 'Active', value: 'active' },
	false: { label: 'Inactive', value: 'inactive' },
};

export const LOWEST_PRICE_STATUS_OBJECT = {
	true: { label: 'Visiable', value: 'active' },
	false: { label: 'Not Visiable', value: 'inactive' },
};

export const PERIOD_STATUSES = {
	ON_GOING: 'ongoing',
	SCHEDULE: 'scheduled',
	EXPIRED: 'expired',
};

export const PERIOD_STATUS_LABELS = {
	[PERIOD_STATUSES.ON_GOING]: 'Ongoing',
	[PERIOD_STATUSES.SCHEDULE]: 'Scheduled',
	[PERIOD_STATUSES.EXPIRED]: 'Expired',
};

export const PERIOD_STATUS_COLOR = {
	[PERIOD_STATUSES.ON_GOING]: 'orange',
	[PERIOD_STATUSES.SCHEDULE]: 'info',
	[PERIOD_STATUSES.EXPIRED]: 'alto',
};